"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userHandlers = exports.forgotEmail = exports.getAnnouncements = exports.unsubscribeFromPushNotifications = exports.subscribeToPushNotifications = exports.changePharmacy = exports.changePassword = exports.postForgotPassword = exports.getForgotPassword = exports.me = exports.registerVerification = exports.registerSelection = exports.register = exports.login = exports.deleteUser = exports.updateUser = void 0;
var instance_1 = require("./instance");
var pharmacy_1 = require("./pharmacy");
var msw_1 = require("msw");
var mock = {};
function updateUser(user) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/User",
        method: "POST",
        data: user,
    })
        .then(function (result) { return result.data; });
}
exports.updateUser = updateUser;
mock.updateUser = function () {
    return msw_1.rest.post("".concat((0, instance_1.getBaseURL)(), "/User"), function (req, res, ctx) {
        return res(ctx.delay(2000), ctx.status(200));
        // return res(
        //   ctx.delay(3000),
        //   ctx.status(400),
        //   ctx.json({
        //     errors: {
        //       FirstName: ["First name is invalid"],
        //       LastName: ["Last name is invalid"],
        //       Email: ["Email is invalid"],
        //     },
        //   }),
        // );
    });
};
function deleteUser() {
    return (0, instance_1.getInstance)()
        .request({
        url: "/User",
        method: "DELETE",
    })
        .then(function (result) { return result.status; });
}
exports.deleteUser = deleteUser;
mock.deleteUser = function () {
    return msw_1.rest.delete("".concat((0, instance_1.getBaseURL)(), "/User"), function (req, res, ctx) {
        return res(ctx.delay(2000), ctx.status(200));
    });
};
function login(user) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/User/authenticate",
        method: "POST",
        data: user,
    })
        .then(function (result) { return result.data; });
}
exports.login = login;
mock.login = function () {
    return msw_1.rest.post("".concat((0, instance_1.getBaseURL)(), "/User/authenticate"), function (req, res, ctx) {
        return res(ctx.delay(2000), ctx.status(200), ctx.json({
            id: 1002,
            firstName: "Paul",
            lastName: "Francis",
            username: "pfrancis@thebhwgroup.com",
            token: "eyJhbGciOiJIUzI1NiIsInR5cCI5IkpXVCJ9.eyJpZCI6IjIiLCJuYmYiOjE2NTY2ODczNjksImV4cCI6MTY1Njc3Mzc2OSwiaWF0IjoxNjU2Njg3MzY5fQ.khhJXiFXx4wHOfrlJXWrNSjcoq1Ikr_SoC-SjTyA6Ls",
        }));
    });
};
function register(data) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/User/register",
        method: "POST",
        data: data,
    })
        .then(function (result) { return result.data; });
}
exports.register = register;
mock.register = function () {
    return msw_1.rest.post("".concat((0, instance_1.getBaseURL)(), "/User/register"), function (req, res, ctx) {
        return res(ctx.delay(3000), ctx.status(200), ctx.json({
            selections: [
                {
                    id: 0,
                    value: "XXX-XXX-1234",
                    selectionType: "PhoneNumber",
                },
                {
                    id: 1,
                    value: "q******w@gmail.com",
                    selectionType: "Email",
                },
            ],
            temporaryPatientId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            prompt: "",
        }));
        // return res(
        //   ctx.delay(3000),
        //   ctx.status(400),
        //   ctx.json({
        //     errors: {
        //       Password: ["Password is invalid"],
        //       FirstName: ["First name is invalid"],
        //       LastName: ["Last name is invalid"],
        //       DateOfBirth: ["Date of birth is invalid"],
        //       Email: ["Email is invalid"],
        //       PreviousScriptNumber: ["Previous script number is invalid"],
        //     },
        //   }),
        // );
    });
};
function registerSelection(selectionInfo) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/User/register/selection",
        method: "PUT",
        params: selectionInfo,
    })
        .then(function (result) { return result.data; });
}
exports.registerSelection = registerSelection;
mock.registerSelection = function () {
    return msw_1.rest.put("".concat((0, instance_1.getBaseURL)(), "/User/register/selection"), function (req, res, ctx) {
        return res(ctx.delay(3000), ctx.status(200));
    });
};
function registerVerification(verificationInfo) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/User/register/verification",
        method: "POST",
        data: verificationInfo,
    })
        .then(function (result) { return result.data; });
}
exports.registerVerification = registerVerification;
mock.registerVerification = function () {
    return msw_1.rest.post("".concat((0, instance_1.getBaseURL)(), "/User/register/verification"), function (req, res, ctx) {
        return res(ctx.delay(3000), ctx.status(200));
    });
};
function me() {
    return (0, instance_1.getInstance)()
        .request({
        url: "/User/me",
        method: "GET",
    })
        .then(function (result) { return (__assign(__assign({}, result.data), { dateOfBirth: new Date(result.data.dateOfBirth) })); });
}
exports.me = me;
mock.me = function () {
    return msw_1.rest.get("".concat((0, instance_1.getBaseURL)(), "/User/me"), function (req, res, ctx) {
        if (!req.headers.get("authorization")) {
            return res(ctx.delay(), ctx.status(401));
        }
        return res(ctx.delay(), ctx.status(200), ctx.json({
            id: 1002,
            firstName: "Paul",
            lastName: "Francis",
            dateOfBirth: "2000-06-17T00:00:00",
            email: "pfrancis@thebhwgroup.com",
            phoneNumber: null,
            pharmacy: pharmacy_1.mockPharmacy,
            patientId: "1234",
            notificationPreference: 0,
            linkedPatients: [
                { patientId: "1234", firstName: "Kuma", lastName: "Francis" },
            ],
        }));
    });
};
function getForgotPassword(email) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/User/ForgotPassword",
        method: "GET",
        params: { email: email },
    })
        .then(function (result) { return result.data; });
}
exports.getForgotPassword = getForgotPassword;
mock.getForgotPassword = function () {
    return msw_1.rest.get("".concat((0, instance_1.getBaseURL)(), "/User/ForgotPassword"), function (req, res, ctx) {
        return res(ctx.delay(3000), ctx.status(200));
    });
};
function postForgotPassword(forgotPasswordPostBody) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/User/ForgotPassword",
        method: "POST",
        data: forgotPasswordPostBody,
    })
        .then(function (response) { return response.data; });
}
exports.postForgotPassword = postForgotPassword;
mock.postForgotPassword = function () {
    return msw_1.rest.post("".concat((0, instance_1.getBaseURL)(), "/User/ForgotPassword"), function (_, res, ctx) {
        return res(ctx.delay(), ctx.status(200));
    });
};
function changePassword(data) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/User/ChangePassword",
        method: "PUT",
        data: data,
    })
        .then(function (response) { return response.data; });
}
exports.changePassword = changePassword;
mock.changePassword = function () {
    return msw_1.rest.put("".concat((0, instance_1.getBaseURL)(), "/User/ChangePassword"), function (_, res, ctx) {
        return res(ctx.delay(3000), ctx.status(200));
        // return res(
        //   ctx.delay(3000),
        //   ctx.status(400),
        //   ctx.json({
        //     errors: {
        //       PreviousPassword: ["Password is invalid"],
        //       NewPassword: ["Password is invalid"],
        //     },
        //   }),
        // );
    });
};
function changePharmacy(data) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/User/ChangePharmacy",
        method: "POST",
        data: data,
    })
        .then(function (response) { return response.data; });
}
exports.changePharmacy = changePharmacy;
mock.changePharmacy = function () {
    return msw_1.rest.put("".concat((0, instance_1.getBaseURL)(), "/User/ChangePharmacy"), function (_, res, ctx) {
        return res(ctx.delay(3000), ctx.status(200), ctx.json({
            selections: [
                {
                    id: 0,
                    value: "XXX-XXX-1234",
                    selectionType: "PhoneNumber",
                },
                {
                    id: 1,
                    value: "q******w@gmail.com",
                    selectionType: "Email",
                },
            ],
            temporaryPatientId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            prompt: "",
        }));
    });
};
function subscribeToPushNotifications(data) {
    return (0, instance_1.getInstance)().request({
        url: "/User/pushToken",
        method: "POST",
        data: {
            TokenString: data.token,
            TokenType: data.type,
        },
    });
}
exports.subscribeToPushNotifications = subscribeToPushNotifications;
mock.subscribeToPushNotifications = function () {
    return msw_1.rest.post("".concat((0, instance_1.getBaseURL)(), "/User/pushToken"), function (_, res, ctx) {
        return res(ctx.status(200));
    });
};
function unsubscribeFromPushNotifications(token) {
    return (0, instance_1.getInstance)().request({
        url: "/User/pushToken",
        method: "DELETE",
        data: { token: token },
    });
}
exports.unsubscribeFromPushNotifications = unsubscribeFromPushNotifications;
mock.unsubscribeFromPushNotifications = function () {
    return msw_1.rest.delete("".concat((0, instance_1.getBaseURL)(), "/User/pushToken"), function (_, res, ctx) {
        return res(ctx.status(200));
    });
};
function getAnnouncements() {
    return (0, instance_1.getInstance)()
        .request({
        url: "/User/announcements",
        method: "GET",
    })
        .then(function (response) {
        return response.data.map(function (a) { return (__assign(__assign({}, a), { datestamp: new Date(a.datestamp) })); });
    });
}
exports.getAnnouncements = getAnnouncements;
var mockAnnouncements = [
    {
        id: "100",
        pharmacyId: pharmacy_1.mockPharmacy.id,
        header: "New medications available",
        body: "Even more medications are now available! Visit your local pharmacy for more details.",
        datestamp: "2023-11-01",
    },
    {
        id: "101",
        pharmacyId: pharmacy_1.mockPharmacy.id,
        header: "Discount on medications",
        body: "It's time for our yearly sale on medications! Try some new ones, who knows what'll happen!",
        datestamp: "2023-11-08",
    },
];
mock.getAnnouncements = function () {
    return msw_1.rest.get("".concat((0, instance_1.getBaseURL)(), "/User/announcements"), function (req, res, ctx) {
        return res(ctx.status(200), ctx.json(mockAnnouncements));
    });
};
function forgotEmail(data) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/User/ForgotEmail",
        method: "POST",
        data: data,
    })
        .then(function (response) { return response.data; });
}
exports.forgotEmail = forgotEmail;
mock.forgotEmail = function () {
    return msw_1.rest.post("".concat((0, instance_1.getBaseURL)(), "/User/ForgotEmail"), function (_, res, ctx) {
        return res(ctx.delay(), ctx.status(200), ctx.json({
            id: 1002,
            firstName: "Paul",
            lastName: "Francis",
            dateOfBirth: "2000-06-17T00:00:00",
            email: "pfrancis@thebhwgroup.com",
            phoneNumber: null,
            pharmacy: pharmacy_1.mockPharmacy,
            patientId: "1234",
            notificationPreference: 0,
            linkedPatients: [
                { patientId: "1234", firstName: "Kuma", lastName: "Francis" },
            ],
        }));
    });
};
exports.userHandlers = mock;
